var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockHour5 = function SvgClockHour5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5 13.334a9.167 9.167 0 1 0-18.334-.001 9.167 9.167 0 0 0 18.334 0m1.666 0a10.833 10.833 0 1 1-21.666 0 10.833 10.833 0 0 1 21.666 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.87 12.64a.833.833 0 0 1 1.156.231l2.223 3.334a.833.833 0 1 1-1.387.924l-2.222-3.333a.833.833 0 0 1 .23-1.156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 13.334V7.778a.833.833 0 0 1 1.666 0v5.556a.833.833 0 0 1-1.667 0"
  })));
};
export default SvgClockHour5;